<template>
  <!-- <div class="important-notice ml-2 mr-2 mt-2">
    <div style="font-size: 1.1em">
      <div class="grid">
        <div class="col-12">
          <h5 style="font-weight: bold; color: red; font-size: 1.2em">
            <i class="pi pi-info-circle"></i> Important Notice!
          </h5>
          <b>Limitation of Work Creation (All Units) :</b><br />
          <ul class="list-group">
            <li class="list-group-item">
              10 June 2024: <b>For All excluded (Gresik, Padang & Malaysia)</b>,
              will be disabled in the creation of Work on the old system.
            </li>
          </ul>

          <br /><b>Deactivation of User Accounts (All Units) :</b><br />
          <ul class="list-group">
            <li class="list-group-item">
              14 June 2024:<b>
                For all user acoounts excluded (Gresik, Padang & Malaysia)</b
              >
              on the old system will be deactivated.
            </li>
          </ul>

          <b>Regarding this matter, we would like to ask all units:</b><br />
          <ul class="list-group">
            <li class="list-group-item">
              Immediately conduct training to all employees and contractors
              regarding the use of the WEPTW Revamp (New) system.
            </li>
            <li class="list-group-item">
              Start using the WEPTW Revamp (New) system for all Work & Permit
              related activities as a whole.
            </li>
            <li class="list-group-item">
              Migrate data (Work & Permit) from the old WEPTW system to the
              WEPTW Revamp (New) system.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div> -->

  <div
    class="login-body"
    style="background-image: url(assets/layout/images/bg3.jpg); font-size: 14px"
  >
    <div class="login-panel ui-fluid">
      <div class="login-panel-header">
        <img src="assets/layout/images/wilmar-logo.png" style="" />
      </div>
      <div class="login-panel-content">
        <div class="flex flex-row flex-wrap grid p-fluid">
          <div class="col-12" style="padding-top: 0.2em !important">
            <h1>{{ $APP_NAME }}</h1>
            <h2>Welcome, login to start your session</h2>

            <CustomSelectButton
              v-model="selectedStatus"
              :options="statusList"
              optionLabel="option"
              class="p-text-center"
              @change="onStatusChange"
              :setDefault="true"
            >
              <template #option="slotProps">
                <div class="p-text-center" style="width: 100%">
                  {{ slotProps.option }}
                </div>
              </template>
            </CustomSelectButton>
          </div>

          <form
            @submit.prevent="handleSubmit(!v$.$invalid)"
            class="col-12"
            style="padding: 0.5em !important"
          >
            <div class="flex flex-row flex-wrap">
              <div class="col-12" style="padding-top: 0 !important">
                <div v-show="submitted && errormessage">
                  <Message severity="error" :closable="false">
                    <template v-slot:default>
                      <span v-html="errormessage"></span>
                    </template>
                  </Message>
                </div>
                <div v-show="successmessage">
                  <Message severity="success" :closable="false">{{
                    successmessage
                  }}</Message>
                </div>
                <div v-show="changePasswordSuccess">
                  <Message severity="success" :closable="false"
                    >{{ changePasswordSuccess }}. Please login using new
                    password</Message
                  >
                </div>

                <div v-if="statusConfirm == 'confirmed'">
                  <Message severity="success" :closable="false"
                    >Your Account Has Been Confirmed
                  </Message>
                </div>
                <div v-else-if="statusConfirm == 'failed-confirmed'">
                  <Message severity="error" :closable="false"
                    >Your account failed to be confirmed
                  </Message>
                </div>
                <div v-else></div>
                <div v-if="isExpired">
                  <Message severity="error" :closable="true"
                    >Session Expired</Message
                  >
                </div>
              </div>
              <div class="col-12 ml-2 mr-2" v-if="register || login">
                <span class="p-float-label">
                  <!--<input class="p-inputtext p-component" id="Username" v-model="Username" type="text" style="width: 100%;">-->
                  <InputText
                    v-model="username"
                    type="text"
                    id="username"
                    style="width: 100%"
                    :class="{ 'p-invalid': v$.username.$invalid && submitted }"
                  />
                  <label for="username">Username</label>
                </span>
                <small
                  v-if="
                    (v$.username.$invalid && submitted) ||
                    v$.username.$pending.$response
                  "
                  class="p-error"
                  >{{
                    v$.username.required.$message.replace("Value", "Username")
                  }}</small
                >
              </div>
              <div class="col-7 ml-3 flex-1" v-if="register">
                <span class="p-float-label">
                  <!--<input class="p-inputtext p-component" id="Username" v-model="Username" type="text" style="width: 100%;">-->
                  <InputText
                    v-model="fullname"
                    type="text"
                    id="fullname"
                    style="width: 100%"
                    :class="{ 'p-invalid': !fullname && submitted }"
                  />
                  <label for="fullname">Full Name</label>
                </span>
                <small v-if="!fullname && submitted" class="p-error">{{
                  $t("is_required").replace("Value", "Fullname")
                }}</small>
              </div>
              <div class="col-5 ml-2" v-if="register">
                <span class="p-float-label">
                  <!--<input class="p-inputtext p-component" id="Username" v-model="Username" type="text" style="width: 100%;">-->
                  <InputText
                    v-model="phone"
                    id="phone"
                    style="width: 100%"
                    :useGrouping="false"
                    @keypress="isNumber($event)"
                    :class="{ 'p-invalid': !phone && submitted }"
                  />
                  <label for="phone">Phone / WhatsApp</label>
                </span>
                <small
                  v-if="(!phone && submitted) || v$.phone.$pending.$response"
                  class="p-error"
                  >{{ $t("is_required").replace("Value", "Phone") }}</small
                >
              </div>
              <div class="col-12 ml-2 mr-2" v-if="register || forgotpass">
                <span class="p-float-label">
                  <!--<input class="p-inputtext p-component" id="Username" v-model="Username" type="text" style="width: 100%;">-->
                  <InputText
                    v-model="email"
                    type="email"
                    id="email"
                    style="width: 100%"
                    :class="{ 'p-invalid': !email && submitted }"
                  />
                  <label for="email">Email</label>
                </span>
                <small
                  v-if="(!email && submitted) || v$.email.$pending.$response"
                  class="p-error"
                  >{{ $t("is_required").replace("Value", "Email") }}</small
                >
              </div>

              <div class="col-12 ml-2 mr-2 mt-1" v-if="login">
                <span class="p-float-label">
                  <!--<input class="p-inputtext p-component" id="Username" v-model="Username" type="text" style="width: 100%;">-->
                  <Password
                    v-model="password"
                    id="password"
                    style="width: 100%"
                    inputStyle="width:100%"
                    :feedback="false"
                    :class="{ 'p-invalid': v$.password.$invalid && submitted }"
                    toggleMask
                  />
                  <label for="password">Password</label>
                </span>
                <small
                  v-if="
                    (v$.password.$invalid && submitted) ||
                    v$.password.$pending.$response
                  "
                  class="p-error"
                  >{{
                    v$.password.required.$message.replace("Value", "Password")
                  }}</small
                >
              </div>

              <div class="col-8 ml-3 flex-1" v-if="register">
                <span class="p-float-label">
                  <!--<input class="p-inputtext p-component" id="Username" v-model="Username" type="text" style="width: 100%;">-->
                  <Password
                    v-model="password"
                    id="password"
                    style="width: 100%"
                    inputStyle="width:100%"
                    :feedback="false"
                    :class="{ 'p-invalid': v$.password.$invalid && submitted }"
                    toggleMask
                  />
                  <label for="password">Password</label>
                </span>
                <small
                  v-if="
                    (v$.password.$invalid && submitted) ||
                    v$.password.$pending.$response
                  "
                  class="p-error"
                  >{{
                    v$.password.required.$message.replace("Value", "Password")
                  }}</small
                >
              </div>
              <div class="col-4 ml-3 flex-1" v-if="register">
                <span class="p-float-label">
                  <Button
                    class="p-button p-component p-button-md"
                    type="submit"
                    :disabled="processing"
                  >
                    <span
                      class="p-button-label"
                      v-if="!processing"
                      style="font-family: Arial"
                      >Register</span
                    >
                    <i
                      class="pi pi-spin pi-spinner"
                      style="margin: auto; font-size: 1.5rem"
                      v-else-if="processing"
                    ></i>
                  </Button>
                </span>
              </div>
              <div class="col-4 ml-3 flex-1" v-if="forgotpass">
                <span class="p-float-label">
                  <Button
                    class="p-button p-component p-button-md"
                    :disabled="processing"
                    @click="sendNewPass()"
                  >
                    <span
                      class="p-button-label"
                      v-if="!processing"
                      style="font-family: Arial"
                      >Reset Password</span
                    >
                    <i
                      class="pi pi-spin pi-spinner"
                      style="margin: auto; font-size: 1.5rem"
                      v-else-if="processing"
                    ></i>
                  </Button>
                </span>
              </div>
              <div
                class="col-12 ml-2 mr-2"
                style="
                  padding-top: 0.3em !important;
                  padding-bottom: 0.3em !important;
                "
                v-if="useCaptcha && login"
              >
                <div
                  class="grid"
                  style="vertical-align: middle !important; align-items: center"
                >
                  <div
                    class="col-6 recaptcha-container"
                    style="padding: 0 !important"
                  >
                    <Captcha
                      :value="captcha"
                      @isValid="checkValidCaptcha"
                      @getCode="getCaptchaCode"
                    />
                  </div>
                  <div class="col-6" style="padding: 0 !important">
                    <span class="p-float-label">
                      <!--<input class="p-inputtext p-component" id="Username" v-model="Username" type="text" style="width: 100%;">-->
                      <InputText
                        v-model="captcha"
                        type="text"
                        id="captcha"
                        style="width: 100%"
                        :class="{
                          'p-invalid': v$.captcha.$invalid && submitted,
                        }"
                        capitalMode="false"
                      />
                      <label for="captcha">Captcha</label>
                    </span>
                    <small
                      v-if="
                        (v$.captcha.$invalid && submitted) ||
                        v$.captcha.$pending.$response
                      "
                      class="p-error"
                      >{{
                        v$.captcha.required.$message.replace("Value", "Captcha")
                      }}</small
                    >
                  </div>
                </div>
              </div>

              <div
                :class="'col-12 ml-2 mr-2 ' + (useCaptcha ? '' : 'mt-6')"
                v-if="login"
              >
                <div class="grid">
                  <div class="col-5">
                    <!-- <a href="assets/mobile/ITM.apk" download="ITM.apk" class="p-button p-button-success p-button-lg" style="text-align:center">
                                                <span class="p-button-label">Android App</span>
                                            </a> -->
                  </div>
                  <div class="col-2"></div>
                  <div class="col-5" style="text-align: right">
                    <Button
                      class="p-button p-component p-button-lg"
                      type="submit"
                      :disabled="processing"
                    >
                      <span
                        class="p-button-label"
                        v-if="!processing"
                        style="font-family: Arial"
                        >Login</span
                      >
                      <i
                        class="pi pi-spin pi-spinner"
                        style="margin: auto; font-size: 1.5rem"
                        v-else-if="processing"
                      ></i>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <ChangePassword
    v-if="changePassword"
    :isVisible="changePassword"
    :userId="username"
    :requireCurrentPassword="true"
    :initialErrorMessage="errormessage"
    @hide="hideChangePasswordDialog"
  />

  <PrivacyPolicy
    v-if="confirmPrivacyPolicy"
    :isVisible="confirmPrivacyPolicy"
    :userId="username"
    :userdata="userdata"
    :requireCurrentPassword="true"
    :initialErrorMessage="errormessage"
    @hide="hideConfirmPrivacyPolicyDialog"
  />

  <ChooseConfirmation
    v-if="chooseConfirmation"
    :isVisible="chooseConfirmation"
    :username="scUsername"
    :email="scEmail"
    :phone="scPhone"
    :mode="scMode"
    :headerTab="scHeader"
    :requireCurrentPassword="true"
    :initialErrorMessage="errormessage"
    @hide="hideChooseConfirmationDialog"
  />
</template>

<script>
import { ref } from "vue";
import { required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import VueClientRecaptcha from "vue-client-recaptcha";
import "vue-client-recaptcha/dist/style.css";

export default {
  components: {
    Captcha: VueClientRecaptcha,
  },
  name: "Login",
  setup: () => ({ v$: useVuelidate() }),
  props: {
    sessionExpired: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      scHeader: "",
      scUsername: "",
      scEmail: "",
      scPhone: "",
      scMode: "",
      username: "",
      password: "",
      fullname: "",
      email: "",
      phone: "",
      repassword: "",
      submitted: false,
      processing: false,
      errormessage: "",
      successmessage: "",
      changePassword: false,
      confirmPrivacyPolicy: false,
      changePasswordSuccess: "",
      chooseConfirmation: false,
      registerdata: null,
      forgotpassdata: null,
      captchaText: null,
      userdata: null,
      captcha: null,
      captchaToken: btoa(this.$secret_key) + btoa(this.$secret_key_uniq),
      tknFrom: null,
      statusConfirm: "",
      tknTo: null,
      captchaValid: false,
      isExpired: this.sessionExpired == "Y",
      statusList: {
        Login: "Login",
        Register: "Register",
        ForgotPass: "Forgot Password",
      },
      selectedStatus: null,
      selectedCategoryIndex: 0,
    };
  },
  validations() {
    return {
      username: {
        required,
      },
      password: {
        required,
      },
      repassword: {},
      fullname: {},
      email: {},
      phone: {},
      captcha: {
        required: requiredIf(() => {
          return this.useCaptcha;
        }),
      },
    };
  },
  methods: {
    checkValidCaptcha(success) {
      this.captchaValid = success;
    },
    getCaptchaCode(value) {
      /* you can access captcha code */
      this.captchaText = value;
      //console.log(value);
    },
    hideChangePasswordDialog(event) {
      this.changePassword = false;
      this.errormessage = "";

      if (event && event.success) {
        this.changePasswordSuccess = event.message;
      }
    },
    getMenuBegde(userData){
    var menuApproval = userData.Menus.find(field => field.label == "Approval");
    
    var self = this;
    this.$axios.get(this.$API_URL + "welcome/getCount" + "/" + userData.Username + "/" + userData.CompanyCode + "/" + userData.IsAdmin)
        .then((response)=>{

            if(response.data.success){
                var data = {
                    item: menuApproval,
                    count: response.data.totalRecords.toString()
                };

                console.log("Menu Badge Approval Count : " + response.data.totalRecords.toString());

                self.$store.dispatch("setMenu", data);
            
            }else{
                self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
            }
        })
        .catch(function (err){
            self.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
        });
    },
    hideConfirmPrivacyPolicyDialog(event) {
      if (event.success) {
        this.confirmPrivacyPolicy = false;
        this.errormessage = null;

        this.$store.dispatch("login", this.userdata);

        this.$axios.defaults.headers.common["Authorization"] =
          this.userdata.user_data.Token;

        this.$axios.defaults.headers.common["language"] =
          this.userdata.user_data.Language;

        this.$router.push("/");
      }
    },
    hideChooseConfirmationDialog(event) {
      if (event.success) {
        this.chooseConfirmation = false;
        this.successmessage = event.message;
        this.errormessage = null;
      } else {
        this.errormessage = event.message;
        this.successmessage = null;
      }

      if (this.selectedCategoryIndex == 2) {
        this.submitted = false;
        this.processing = false;
        this.email = "";
      }
    },
    onStatusChange(event) {
      this.selectedStatus = event.value;
      this.selectedCategoryIndex = event.index;
      this.errormessage = null;
      this.successmessage = null;
      this.username = "";
      this.password = "";
      this.fullname = "";
      this.email = "";
      this.phone = "";
      this.submitted = false;
      this.processing = false;
    },
    handleSubmit(isFormVaild) {
      this.submitted = true;

      if (this.selectedCategoryIndex != 2) {
        if (!isFormVaild) {
          return;
        }
      }

      this.errormessage = "";

      if (this.useCaptcha) {
        if (!this.captchaValid) {
          this.errormessage = "Invalid/Incorrect Captcha";
          return;
        }
      }

      this.processing = true;
      this.messages = [];
      this.changePasswordSuccess = "";

      var self = this;

      if (this.selectedCategoryIndex == 0) {
        this.$axios
          .post(this.$API_URL + "auth/login", {
            Username: this.username,
            Password: this.password,
            Captcha: this.captcha,
            CaptchaToken: this.captchaToken,
            CaptchaText: btoa(this.captchaText),
          })
          .then((response) => {
            if (response) {
              if (response.data.success) {
                if (response.data.message_code == "NEED_CONFIRM") {
                  self.userdata = response.data.data;
                  self.confirmPrivacyPolicy = true;
                } else {
                  self.$store.dispatch("login", response.data.data);
                  self.$axios.defaults.headers.common["Authorization"] =
                    response.data.data.user_data.Token;
                  self.$axios.defaults.headers.common["language"] =
                    response.data.data.user_data.Language;
                     self.getMenuBegde(response.data.data.user_data);
                  self.$root.$i18n.locale =
                    response.data.data.user_data.Language;
                  self.$root.$i18n.global.locale.value =
                    response.data.data.user_data.Language;
                  self.$router.push("/");
                }
              } else {
                if (response.data.message == "Captcha is Required") {
                  self.$store.dispatch("setCaptchaCountLock");
                }

                if (
                  response.data.message_code == "FIRST_LOGIN" ||
                  response.data.message_code == "CHANGE_PASS"
                ) {
                  self.changePassword = true;
                } else if (response.data.message_code == "CAPTCHA") {
                  self.$store.dispatch("setCaptchaCount");
                } else if (response.data.message_code == "NEED_VERIFICATION") {
                  self.scEmail = response.data.data.Email;
                  self.scPhone = response.data.data.Phone;
                  self.scUsername = response.data.data.Username;
                  self.scMode = "ACTIVATION_ACCOUNT";
                  self.scHeader = "Account Activation Method";
                  self.chooseConfirmation = true;
                }

                self.errormessage = response.data.message;
                self.processing = false;
              }
            } else {
              self.errormessage = response.message;
              self.processing = false;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 404) {
                self.errormessage = "Resource not found.";
              } else {
                self.errormessage =
                  "An error occurred (Undifined Status). Please try again later.";
              }
            } else if (error.request) {
              self.errormessage =
                "No response from server. Please check your connection.";
            } else {
              self.errormessage =
                "An unexpected error occurred (Undifined Status). Please try again later.";
            }

            self.processing = false;
          });
      } else if (this.selectedCategoryIndex == 1) {
        if (
          !this.username ||
          !this.fullname ||
          !this.email ||
          !this.phone ||
          !this.password
        ) {
          self.errormessage = "Please complete all existing fields";
          self.processing = false;
        } else {
          this.registerdata = {
            Username: this.username,
            Fullname: this.fullname,
            Email: this.email,
            Phone: this.phone,
            Password: this.password,
          };

          this.$axios
            .post(this.$API_URL + "auth/register", this.registerdata)
            .then((response) => {
              if (response) {
                //console.log(response)
                if (response.data.success) {
                  self.successmessage = response.data.message;
                  self.processing = false;
                  self.submitted = false;

                  self.chooseConfirmation = true;
                  self.scEmail = response.data.data.Email;
                  self.scPhone = response.data.data.Phone;
                  self.scUsername = response.data.data.Username;
                  self.scMode = "ACTIVATION_ACCOUNT";
                  self.scHeader = "Account Activation Method";
                  self.username = "";
                  self.password = "";
                  self.fullname = "";
                  self.email = "";
                  self.phone = "";
                } else {
                  self.successmessage = null;
                  self.errormessage = response.data.message;
                  self.processing = false;
                }
              } else {
                self.errormessage = response.message;
                self.processing = false;
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 404) {
                  self.errormessage = "Resource not found.";
                } else {
                  self.errormessage =
                    "An error occurred (Undifined  Status). Please try again later.";
                }
              } else if (error.request) {
                self.errormessage =
                  "No response from server. Please check your connection.";
              } else {
                self.errormessage =
                  "An unexpected error occurred (Undifined Status). Please try again later.";
              }
              //self.errormessage = error;
              self.processing = false;
            });
        }
      } else if (this.selectedCategoryIndex == 2) {
        if (!this.email) {
          self.errormessage = "Please complete existing fields";
          self.successmessage = "";
          self.processing = false;
        } else {
          this.forgotpassdata = {
            Email: this.email,
          };

          this.$axios
            .post(this.$API_URL + "auth/forgotpassword", this.forgotpassdata)
            .then((response) => {
              if (response) {
                //console.log(response)
                if (response.data.success) {
                  self.successmessage = response.data.message;
                  self.processing = false;
                  self.submitted = false;

                  self.email = "";
                } else {
                  self.successmessage = response.data.message;
                  self.errormessage = "";
                  self.processing = false;
                }
              } else {
                self.errormessage = response.message;
                self.processing = false;
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 404) {
                  self.errormessage = "Resource not found.";
                } else {
                  self.errormessage =
                    "An error occurred (Undifined Status). Please try again later.";
                }
              } else if (error.request) {
                self.errormessage =
                  "No response from server. Please check your connection.";
              } else {
                self.errormessage =
                  "An unexpected error occurred (Undifined Status). Please try again later.";
              }

              self.processing = false;
            });
        }
      }
    },
    sendNewPass() {
      this.submitted = true;
      this.processing = true;

      if (!this.email) {
        this.errormessage = "Please complete existing fields";
        this.successmessage = "";
        this.processing = false;
      } else {
        this.errormessage = "";
        this.successmessage = "";
        this.scEmail = this.email;
        this.scMode = "FORGOT_PASSWORD";
        this.scHeader = "Method Send New Password";
        this.chooseConfirmation = true;
      }
    },
    onDownloadMobile(file) {
      var self = this;
      this.$axios
        .get(this.$API_URL + "auth/download_mobile/")
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.name);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found",
            life: 3000,
          });
          self.blocked = false;
          //self.showAssignModal = false;
        });
    },
    // onBlur() {
    //     if (this.selectedCategoryIndex == 1) {
    //         this.$axios.get(this.$API_URL + "auth/" + this.username)
    //             .then((response) => {
    //                 if (response.data.message != "TRUE") {
    //                     console.log("false")
    //                 }
    //                 else {
    //                     console.log("true")
    //                 }
    //             })
    //             .catch(function (error) {
    //                 alert(error);
    //             });
    //     }
    // },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  mounted() {
    if (this.$store.getters.isAuthenticated) this.$router.push("/");

    this.useCaptcaCount = 0;

    var selectedStatusValue = Object.values(this.statusList)[
      this.selectedCategoryIndex
    ];
    if (selectedStatusValue == undefined) {
      this.selectedStatus = Object.values(this.statusList)[0];
    } else {
      this.selectedStatus = selectedStatusValue;
    }
  },
  computed: {
    useCaptcha() {
      return this.$store.getters.getCaptchaCount >= 3;
    },
    login() {
      return this.selectedCategoryIndex == 0;
    },
    register() {
      return this.selectedCategoryIndex == 1;
    },
    forgotpass() {
      return this.selectedCategoryIndex == 2;
    },
  },
  created() {
    this.statusConfirm = this.$route.query.cnf ?? "";
  },
};
</script>

<style scoped>
.p-progress-spinner-circle {
  stroke: white;
}

.recaptcha-container {
  /* Default scale for larger screens */
  transform: scale(0.8);
  transform-origin: 0 0;
}

/* Scale for mobile devices */
@media (max-width: 1024px) {
  .recaptcha-container {
    transform: scale(0.75); /* Adjust the scale for tablet-sized screens */
  }
}

@media (max-width: 768px) {
  .recaptcha-container {
    transform: scale(0.65); /* Adjust the scale for mobile screens */
  }
}

@media (max-width: 480px) {
  .recaptcha-container {
    transform: scale(0.6); /* Adjust the scale for smaller mobile screens */
  }
}

.important-notice {
  border: 2px dashed red;
  background-color: white;
  position: fixed;
  width: 30%;
  display: initial;
}

@media (max-width: 576px) {
  .important-notice {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .important-notice {
    display: none !important;
  }
}
</style>
